export default {
    title: 'الرسائل الواردة',
    empty: 'ليس لديك تنبيهات'
}
